
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"54","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.47 39.707c.072 0 .107.076.107.229 0 .152-.035.228-.107.228-.758 0-1.35-.012-1.777-.038l-2.418-.038-2.524.038c-.427.026-1.008.038-1.743.038-.07 0-.106-.076-.106-.228 0-.153.035-.23.106-.23.901 0 1.565-.063 1.991-.19.427-.127.712-.369.854-.725.142-.381.213-.953.213-1.716V19.567c0-.864-.047-1.436-.142-1.716-.071-.28-.273-.458-.605-.534-.331-.076-1.007-.114-2.026-.114h-7.29c-1.066 0-1.777.038-2.133.114-.355.076-.58.267-.675.572-.095.28-.142.84-.142 1.678v17.508c0 .763.07 1.335.213 1.716.166.356.45.598.853.725.427.127 1.103.19 2.027.19.047 0 .071.077.071.23 0 .152-.024.228-.071.228-.735 0-1.316-.012-1.742-.038l-2.56-.038-2.418.038c-.427.026-1.02.038-1.778.038-.047 0-.07-.076-.07-.228 0-.153.023-.23.07-.23.901 0 1.565-.063 1.991-.19.45-.127.747-.369.89-.725.165-.381.248-.953.248-1.716V19.872c0-.788-.083-1.398-.249-1.83-.142-.433-.438-.75-.889-.954-.45-.203-1.102-.305-1.955-.305-.048 0-.071-.076-.071-.229 0-.152.023-.229.07-.229a67 67 0 012.312.038c3.081.051 6.317.077 9.707.077 3.081 0 6.613-.039 10.595-.115h1.174c.07 0 .106.076.106.23 0 .152-.035.228-.107.228-1.232 0-2.062.229-2.488.686-.403.458-.605 1.26-.605 2.403v17.203c0 .763.071 1.335.213 1.716.166.356.463.598.89.725.426.127 1.09.19 1.99.19z","fill":"#000C1F"}}),_c('rect',{attrs:{"x":"7.077","y":"44.664","width":"11","height":"8","rx":"1.5","stroke":"#000C1F","stroke-dasharray":"4 4"}}),_c('rect',{attrs:{"x":"29.077","y":"21.245","width":"15","height":"11","rx":"1.5","stroke":"#000C1F","stroke-dasharray":"4 4"}})])
          )
        }
      }
    